import { render, staticRenderFns } from "./AppsPage.vue?vue&type=template&id=38751885&scoped=true&"
import script from "./AppsPage.vue?vue&type=script&lang=js&"
export * from "./AppsPage.vue?vue&type=script&lang=js&"
import style0 from "./AppsPage.vue?vue&type=style&index=0&id=38751885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38751885",
  null
  
)

export default component.exports